// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"ContainerStyles_snackbarContainer__2E_oT"};